<template>
	<div>
		<v-card>
			<v-card-title>
				<h2>Oferent: {{bidderName}}</h2>
				<v-spacer></v-spacer>
			</v-card-title>
			<v-tabs class="tabs" centered grow height="60px">
				<v-tab v-for="tab in tabs" :key="tab.id" :to="tab.route" exact>{{ tab.name }}</v-tab>
			</v-tabs>
			<router-view>
			</router-view>
		</v-card>
	</div>
</template>

<script>
	import {Bidder} from "@/api/generated/Bidder";

	export default {
		name: "BidderDataViewTemplate",
		data () {
			return {
				bidderName: '',
				tabs: [
					{id: 1, name: "Konkursy", route: `/app/bidder-data/${this.$route.params.bidderId}/contest-list`},
					{id: 2, name: "Oferty", route: `/app/bidder-data/${this.$route.params.bidderId}/offer-list`},
					{
						id: 3,
						name: "oceny przebiegu współpracy ",
						route: `/app/bidder-data/${this.$route.params.bidderId}/evaluation-list`
					},
					{
						id: 4,
						name: "Raporty z monitoringów",
						route: `/app/bidder-data/${this.$route.params.bidderId}/monitoring-list`
					}
				]
			};
		},

		created () {
			Bidder.getPolishName(this, this.$route.params.bidderId,
				onSuccess => {
					this.bidderName = onSuccess.name;
				});
		}
	};
</script>

<style scoped>

</style>
